import React from "react";
import RecordContainer from "../../components/Record/RecordContainer";
import { parsedUser } from "../../common/GetCurrentUser";
import { Routes } from "../../routes";

const BackgroundCheckReportPage = () => {
    const user = parsedUser();
    if (!user) {
        window.location.href = Routes.SignIn.path;
        return null;
    }

    document.title = window.location.href.includes("backgroundcheck")
        ? "Background Check"
        : "Data Worker"
    return <RecordContainer backgroundCheck={true} />
}

export default BackgroundCheckReportPage;
